<template>
    <div v-if="!video">
        <android-file-picker
            :id="'content-video-' + record.ref"
            mode="single"
            type="Video"
            v-if="androidFilePickerOpen"
        ></android-file-picker>
        <label class="plusIcon" @click="openFileAndroid">
            <plus-icon class="icon" />
            <input @change="selectFile" type="file" accept="video/mp4,video/x-m4v,video/*" />
        </label>
        <button
            v-if="editMode && !record.is_player_submitted"
            class="button red deleteSingleImage"
            @click.prevent="deleteSection"
            type="button"
        >
            <img src="@/assets/minus.svg" class="icon" />
        </button>
    </div>
    <div
        class="singleImage video"
        :class="{
            'is-player-submitted': record.is_player_submitted,
            'is-first-player-record': record.is_player_submitted && index == 0,
        }"
        v-else
    >
        <div v-if="record.is_player_submitted && index == 0" class="label">Player video:</div>
        <div v-if="errorLoading">
            <button type="button" class="button red errorloading" @click.prevent="retryDownload">
                Failed to load video, tap here to retry
            </button>
        </div>
        <div v-else-if="!showPreview && !record.saved">
            <button
                type="button"
                class="button btn-video-requires-sync"
                @click.prevent="confirmRecord"
            >
                To view this video sync now
                <br /><br />
                <div class="no-preview-sync-btn">Sync</div>
            </button>
        </div>
        <video v-else :ref="record.ref + record.loadAttempts + 'video'" controls>
            <source
                :ref="record.ref + record.loadAttempts + 'videosource'"
                :src="video"
                type="video/mp4"
            />
        </video>
        <button
            v-if="editMode && !record.is_player_submitted"
            class="button red deleteSingleImage"
            @click.prevent="deleteSection"
            type="button"
        >
            <img src="@/assets/minus.svg" class="icon" />
        </button>
        <img
            src="@/assets/sync-video-eyeball@2x.png"
            class="syncVideoEyeball"
            v-show="!errorLoading && !showPreview && !record.saved"
        />
    </div>
</template>

<script>
import AndroidFilePicker from "@/components/Shared/Android-file-picker";
import { imageURL } from "@/mixins/imageURL.js";
import { PlusIcon } from "vue-feather-icons";
import { isAndroid } from "mobile-device-detect";
import { isIOS, osVersion } from "mobile-device-detect";
export default {
    name: "content-video",
    components: { AndroidFilePicker, PlusIcon },
    mixins: [imageURL],
    props: ["record", "value", "index", "editMode"],
    data() {
        return {
            video: false,
            errorLoading: false,
            oWebViewInterface: window.nsWebViewInterface,
            androidFilePickerOpen: false,
            showPreview: !isIOS || parseFloat(osVersion) <= 15.1, // !isIOS || (parseFloat(osVersion) <= 15), // don't show preview on iOS 15+
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    created() {
        if (this.record.video_url) {
            // the random offset helps to load the file after a network error
            this.video = this.imageURL(
                this.record.video_url + "#t=0.0" + Math.round(Math.random() * 100) + "'",
            );
        } else if (this.record.video) {
            this.video = this.record.video;
        }

        this.oWebViewInterface.on("fileRecieved-content-video-" + this.record.ref, (videoData) => {
            this.inputVal = "data:video/mp4;base64," + String(videoData);
            this.video = "data:video/mp4;base64," + String(videoData);
            this.$emit("saveData");
        });
    },
    mounted() {
        this.listenForVideoError();
    },
    methods: {
        confirmRecord() {
            this.$emit("confirmrecord");
        },
        openFileAndroid() {
            if (isAndroid) {
                this.androidFilePickerOpen = true;
            }
        },
        selectFile(e) {
            var reader = new FileReader();

            reader.onload = (readerEvt) => {
                var binaryString = readerEvt.target.result;
                var string = btoa(binaryString);
                this.inputVal = "data:image/png;base64," + String(string);
                this.video = "data:image/png;base64," + String(string);
                this.$emit("saveData");
            };
            reader.readAsBinaryString(e.target.files[0]);
        },
        deleteSection() {
            this.$emit("sectionDeleted", this.index, this.record);
        },
        listenForVideoError() {
            this.$nextTick(() => {
                const videoSourceElement =
                    this.$refs[this.record.ref + this.record.loadAttempts + "videosource"];
                if (videoSourceElement) {
                    const videoErrorEventListener = videoSourceElement.addEventListener(
                        "error",
                        () => {
                            videoSourceElement.removeEventListener(
                                "error",
                                videoErrorEventListener,
                                true,
                            );
                            this.errorLoading = true;
                        },
                    );
                }
            });
        },
        retryDownload() {
            this.$emit("reloadComponent");
        },
    },
};
</script>

<style lang="scss" scoped>
.label {
    padding: 10px 10px 10px 15px;
    color: $green_0;
}
video {
    width: 100%;
    border-radius: $radius;
    vertical-align: top;
}
.singleImage.video {
    min-height: auto !important;
}
.singleImage.video.is-player-submitted {
    background-color: #f6d5a6 !important;
}
.formGroup {
    position: relative;
}
.deleteSingleImage {
    position: absolute;
    right: 10px;
    width: 40px !important;
    height: 40px !important;
    border-radius: 8px !important;
    top: -10px;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
    .icon {
        width: 9px;
    }
}
.syncVideoEyeball {
    position: absolute;
    left: 10px;
    width: 60px !important;
    height: 60px !important;
    border-radius: 8px !important;
    top: -23px;
    .icon {
        width: 9px;
    }
}
.button.errorloading {
    min-height: 200px;
}
.button.blue {
    background-color: #00a0ff;
}
.button.btn-video-requires-sync {
    min-height: 160px;
    background-color: rgba(21, 242, 159, 1);
    color: rgba(38, 121, 98, 1);
}
.no-preview-sync-btn {
    background-color: rgba(96, 196, 92, 1);
    border-radius: 15px;
    padding: 17px 0;
    color: #fff;
}
.is-first-player-record {
    margin-bottom: 5px !important;
}
</style>
